import "./FourPiecesPiece.css";

export function FourPiecesPiece(props: {
  clues: string[];
  edges: string[] /* north, then west, then east, then south */;
}) {
  const { clues, edges } = props;
  return (
    <>
      <div className="four-pieces-piece no-copy">
        <div className="four-pieces-center">
          <ul>
            {clues.map((clue, i) => (
              <li key={i}>{clue}</li>
            ))}
          </ul>
          <div className="four-pieces-edge four-pieces-n-1">{edges[0]}</div>
          <div className="four-pieces-edge four-pieces-n-2">{edges[1]}</div>
          <div className="four-pieces-edge four-pieces-w-1">{edges[2]}</div>
          <div className="four-pieces-edge four-pieces-w-2">{edges[3]}</div>
          <div className="four-pieces-edge four-pieces-e-1">{edges[4]}</div>
          <div className="four-pieces-edge four-pieces-e-2">{edges[5]}</div>
          <div className="four-pieces-edge four-pieces-s-1">{edges[6]}</div>
          <div className="four-pieces-edge four-pieces-s-2">{edges[7]}</div>
        </div>
      </div>
      <div className="copy-only">
        <table>
          <tbody>
            <tr>
              <td></td>
              <td>{edges[0]}</td>
              <td></td>
              <td>{edges[1]}</td>
              <td></td>
            </tr>
            <tr>
              <td>{edges[2]}</td>
              <td colSpan={3} rowSpan={3}>
                {clues.join("\n")}
              </td>
              <td>{edges[4]}</td>
            </tr>
            <tr>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td>{edges[3]}</td>
              <td>{edges[5]}</td>
            </tr>
            <tr>
              <td></td>
              <td>{edges[6]}</td>
              <td></td>
              <td>{edges[7]}</td>
              <td></td>
            </tr>
          </tbody>
        </table>
      </div>
    </>
  );
}
